const dropdownItems = document.querySelectorAll('.dropdown.header-menu__item');

dropdownItems.forEach(item => {
    const megaMenu = item.querySelector('.mega-menu');
    if (megaMenu) {
    item.addEventListener('mouseenter', () => {
        megaMenu.classList.add('mega-menu--active');
    });

    item.addEventListener('mouseleave', () => {
        megaMenu.classList.remove('mega-menu--active');
    });
    }
});
